export const findInfo = (arr, key) => {
  const rezult = arr?.find((elements) => {
    return elements.key.toLowerCase() === key.toLowerCase();
  });

  return rezult?.value;
};



//функція пошуку значення по властивості атрибуту в AttributeItems

export function findItem(arr, key) {
  const result = arr?.filter((elem) => elem.attribute.slug === key);

  return result?.[0];
}

//функція пошуку значення по властивості атрибуту в AttributeItems змінена

export function findItemUpdated(arr, key) {
  const result = arr?.filter((elem) => elem.attribute.slug.split('_')[0] === key);

  return result?.[0];
}